<script>
import SelectField from '@phoenix/mixins/components/form/fields/SelectField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [SelectField],

  setup(props) {
    return useField(props);
  },

  computed: {
    selectFieldClasses() {
      if (this.isSgphx) {
        return ['sgphx-field--select', this.fieldClasses];
      }

      return ['field--select', this.fieldClasses];
    },

    wrapperClasses() {
      return {
        'sgphx-field--select__wrapper': this.isSgphx,
        'field--select__wrapper': !this.isSgphx,
      };
    },
  },
};
</script>

<template>
  <div :class="wrapperClasses">
    <select
      :id="fieldUniqueId"
      v-model="value"
      :name="field.name"
      :class="selectFieldClasses"
      :aria-describedby="ariaDescribedby"
      :aria-label="field.ariaLabel"
      :placeholder="field.placeholder"
      :disabled="field.disabled"
      autocomplete="disabled"
    >
      <option v-if="emptyChoice" value="" />

      <optgroup v-for="(options, label) in groupedOptions" :key="label" :label="label">
        <option v-for="(option, index) in options" :key="`${label}-${index}`" :value="option.value">
          {{ option.label }}
        </option>
      </optgroup>

      <option v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
